import Vue from 'vue'
import { debounce } from '../../../common/js/common'
import { getScreenSize } from '../../../common/js/dom'

function needToRead(value) {
  return value !== undefined
}

(function () {
  var lastTime = 0
  var vendors = ['webkit']
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] || // Webkit中此取消方法的名字变了
      window[vendors[x] + 'CancelRequestAnimationFrame']
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime()
      var timeToCall = Math.max(0, 16.7 - (currTime - lastTime))
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
  }
})()

export default {
  data() {
    return {
      isHost: false,
      hostUserId: '',
      isReturnToRoom: false,
      viewOverlayShow: false,
      viewOverlayHeight: null,
      stopBodyScroll: false,
      elementsTop: []
    }
  },
  watch: {
    isHost: {
      handler(newVal) {
        this.monitorScroll(this.isForPresentation && newVal)
      },
      immediate: true
    },
    isBoardShow: {
      handler(value) {
        if (!this.isHost) return
        this.stopBodyScroll = value
        // stopBodyScroll(value)
        this.syncDelta({ pbData: { isBoardShow: value } })
      }
    },
    isForPresentation: {
      handler(value) {
        if (!value && parent.window && parent.window.screenAdapter) {
          parent.window.screenAdapter()
        }
      }
    }
  },
  created() {
    // TODO: 全局挂载
    Vue.prototype.syncDelta = this.syncDelta
    this.debounceSyncDelta = debounce(delta => {
      if (this.stopBodyScroll) return
      this.syncDelta(delta)
    }, 100)
    this.rate = 1
  },
  methods: {
    syncDelta(delta) {
      const toolBelt = this.$refs.presentationToolbelt
      if (
        this.isForPresentation &&
        toolBelt &&
        typeof toolBelt.syncDelta === 'function'
      ) {
        toolBelt.syncDelta(delta)
      }
    },
    monitorScroll(isToMonitor) {
      if (!isToMonitor && this.scrollHdl) {
        window.removeEventListener('scroll', this.scrollHdl)
      } else {
        let ticking = false
        this.scrollHdl = window.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              const top =
                document.documentElement.scrollTop ||
                window.pageYOffset ||
                document.body.scrollTop
              this.debounceSyncDelta({
                top,
                topCorrection: this.inViewPort(top)
              })
              ticking = false
            })
            ticking = true
          }
        })
      }
    },
    onPrePageSync(delta) {
      const {
        isHost,
        hostUserId,
        isReturnToRoom,
        windowWidth,
        windowHeight
      } = delta
      const size = getScreenSize()
      if (needToRead(isHost)) {
        this.isHost = isHost
      }
      if (needToRead(hostUserId)) {
        this.hostUserId = hostUserId
      }
      if (windowWidth) {
        this.rate = size.width / windowWidth
      }
      console.log('[prePage], 获得 windowWidth', windowWidth)
      console.log('[prePage], 获得 rate', this.rate)
      console.log('[prePage], 获得 hostUserId', this.hostUserId)
      if (parent.window && parent.window.screenAdapter && !this.adaptered) {
        parent.window.screenAdapter(windowWidth, windowHeight)
        this.adaptered = true
      }
      if (size.height > windowHeight) {
        this.viewOverlayHeight = size.height - windowHeight * this.rate
        this.viewOverlayShow = this.viewOverlayHeight > 0
      }
      if (isReturnToRoom) {
        this.isReturnToRoom = true
        this.onPageSync(delta)
      }
    },
    onPageSync(delta = {}) {
      console.warn('[time] 接收消息时间：', delta)
      if (this.isHost && !this.isBoardShow) {
        return
      }
      const { elementsTop } = this
      const { top, topCorrection, pbData, boardData } = delta
      if (needToRead(top)) {
        const { index, fixTop } = topCorrection
        const targetTop = elementsTop[index] + (fixTop || 0) * this.rate
        if (!Number.isNaN(targetTop)) {
          this.$nextTick(() => {
            window.requestAnimationFrame(() => {
              window.scrollTo({
                top: targetTop,
                left: 0,
                behavior: 'smooth'
              })
            })
          })
        }
      }
      /** pbData */
      if (pbData) {
        this.readPageView(pbData)
      }
      if (
        boardData &&
        Array.isArray(boardData.event) &&
        this.$refs.drawingBoard
      ) {
        // this.$refs.drawingBoard.syncClearRect()
        // const vm = this
        // let eventAnimationFrame
        // function drawingEvent(index) {
        //   if (!boardData.event[index] && eventAnimationFrame) {
        //     window.cancelAnimationFrame(eventAnimationFrame)
        //     return
        //   }
        //   eventAnimationFrame = window.requestAnimationFrame(() => {
        //     vm.readEvent(boardData.event[index])
        //     drawingEvent(index + 1)
        //   })
        // }
        // drawingEvent(0)
        boardData.event.forEach(event => {
          this.readEvent(event)
        })
      }
    },
    readPageView(pbData) {
      const {
        insuranceId,
        isClausesAllShow,
        isClausesShow,
        isClausesDetailShow,
        isDiseasesShow,
        diseasesPath,
        diseaseCurrentProduct,
        diseaseCurrentTitle,
        // isDiseaseDetailShow,
        isDescShow,
        isOverviewShow,
        isNameExplainAllShow,
        isBoardShow,

        interestsCurrentProduct,
        interestsCurrentYear,
        index,
        interestsCurrentBonus,
        interestsCurrentRate,
        // clausesScrollTop,
        diseaseScrollTop,
        // --
        // showType,
        // termsList

        interestDemoV2Setting,
        // 病种同屏数据
        diseaseTypeNew
      } = pbData

      // 病种
      if (needToRead(diseasesPath) || needToRead(isDiseasesShow)) {
        if (Array.isArray(diseasesPath)) {
          this.openDiseaseBubble(diseasesPath)
        } else if (!isDiseasesShow) {
          this.disease.show = isDiseasesShow
        }
      }
      if (needToRead(diseaseCurrentProduct)) {
        this.$refs.diseaseType.syncChangeProduct(diseaseCurrentProduct)
      }
      if (needToRead(diseaseCurrentTitle)) {
        this.$refs.diseaseType.syncChangeCategory(diseaseCurrentTitle)
      }
      if (needToRead(diseaseScrollTop)) {
        this.$refs.diseaseType.$refs.list.scrollTo(0, -diseaseScrollTop, 400)
      }
      // TODO: 病种详情
      // if (needToRead(isDiseaseDetailShow)) {
      // }
      // 条款
      if (needToRead(isClausesAllShow)) {
        this.$refs.termsList.handleToggle(isClausesAllShow)
      }
      if (needToRead(insuranceId) || needToRead(isClausesShow)) {
        if (insuranceId) {
          this.openTermsBubble(insuranceId)
        } else if (!isClausesShow) {
          this.$refs.termsList.asyncClose()
        }
      }
      if (needToRead(isClausesDetailShow)) {
        const termsList = this.$refs.termsList
        const idx = isClausesDetailShow.index
        const item = termsList.terms.list[idx]
        termsList.syncHandleView(item, idx)
      }
      // if (needToRead(clausesScrollTop)) {
      // }
      // 责任
      if (needToRead(isDescShow)) {
        this.$refs.insResult.$refs.liability.toggleDesc(isDescShow)
      }
      if (needToRead(isOverviewShow)) {
        this.$refs.person.toggle(isOverviewShow)
      }
      if (needToRead(isNameExplainAllShow)) {
        this.$refs.nameExplain.toggle(isNameExplainAllShow)
      }
      // 利益演示
      if (needToRead(interestsCurrentProduct)) {
        this.$refs.demons.handlePrdChange(interestsCurrentProduct)
      }
      if (needToRead(interestsCurrentYear)) {
        this.$refs.demons.$refs.demonStrat.curYear = interestsCurrentYear
      }
      if (needToRead(interestsCurrentBonus)) {
        this.$refs.demons.handleBonusChange(interestsCurrentBonus, index)
      }
      if (needToRead(interestsCurrentRate)) {
        this.$refs.demons.handleRateChange(interestsCurrentRate, index)
      }
      // if (needToRead(showType)) {
      //   this.showType = showType
      // }
      if (needToRead(isBoardShow)) {
        this.isBoardShow = isBoardShow
      }
      if (needToRead(interestDemoV2Setting)) {
        this.$refs.InterestDemoV2.update(interestDemoV2Setting)
      }
      if (needToRead(diseaseTypeNew)) {
        this.$refs.diseaseTypeNew.update(diseaseTypeNew)
      }
    },
    readEvent(event) {
      const eventType = event.s
        ? 'touchstart'
        : event.m
          ? 'touchmove'
          : 'touchend'
      let point
      // fix touchend loss
      // if ((this.latestStart || this.isLatestEnd) && eventType === 'touchmove') {
      //   point = event.m.split(',')
      //   event.pageX = point[0] * this.rate
      //   event.pageY = point[1] * this.rate
      //   this.$refs.drawingBoard.handleStart(event)
      //   this.isLatestEnd = false
      //   this.latestStart = false
      // }
      switch (eventType) {
        case 'touchstart':
          // if (this.touchTimer) {
          //   clearTimeout(this.touchTimer)
          // }
          // this.latestStart = true
          point = event.s.split(',')
          event.pageX = point[0] * this.rate
          event.pageY = point[1] * this.rate
          this.$refs.drawingBoard.handleStart(event)
          break
        case 'touchmove':
          // if (this.touchTimer) {
          //   clearTimeout(this.touchTimer)
          // } else {
          //   this.touchTimer = setTimeout(() => {
          //     this.isLatestEnd = true
          //     this.$refs.drawingBoard.handleEnd(event)
          //   }, 500)
          // }
          point = event.m.split(',')
          event.pageX = point[0] * this.rate
          event.pageY = point[1] * this.rate
          this.$refs.drawingBoard.handleMove(event)
          break
        case 'touchend':
          // if (this.touchTimer) {
          //   clearTimeout(this.touchTimer)
          // }
          // this.isLatestEnd = true
          this.$refs.drawingBoard.handleEnd(event)
          break
        default:
      }
    },
    registerDrawEndTimer() {
      if (this.endTimer) {
        clearTimeout(this.endTimer)
      } else {
        this.endTimer = setTimeout(() => {
          this.$refs.drawingBoard.syncEnd(boardData.event)
        }, 500)
      }
    },
    inViewPort(top) {
      const { elementsTop } = this
      let index = this.sortedIndex(elementsTop, top)
      // insbox start 0
      index = index > 0 ? index - 1 : index
      const baseTop = elementsTop[index]
      const fixTop = top - baseTop
      return {
        index,
        fixTop
      }
    },
    sortedIndex(array, value) {
      var low = 0,
        high = array.length
      while (low < high) {
        var mid = (low + high) >>> 1
        if (array[mid] < value) low = mid + 1
        else high = mid
      }
      return low
    }
  },
  beforeDestroy() {
    this.monitorScroll(false)
  }
}
